<template>
  <b-container fluid style="padding: 0">
    <h2>Générateur de dossard</h2>

    <b-row>
      <b-col cols="7">
        <b-form-input v-model="diplome_name" placeholder="Nom du diplome"></b-form-input>
        <div class="canvas-container" id="canvas-global" v-bind:style="{ backgroundImage: 'url(' + url_bg + ')' }">
          <div
            v-for="parameter in parameters"
            class="container_value"
            v-bind:style="{
              color: parameter.couleur,
              fontSize: parameter.taille + 'px',
              fontFamily: parameter.police,
              transform: 'rotate(' + parameter.rotate + 'deg)',
              top: parameter.offsetY + 'px',
              left: parameter.offsetX + 'px',
              fontStyle: parameter.fontStyle,
              fontWeight: parameter.fontWeight,
              display: parameter.display,
            }"
          >
            <p class="distance_text">
              {{ parameter.value }}
            </p>
          </div>
        </div>
      </b-col>
      <b-col>
        <b-row>
          <b-col cols="11">
            <b-form-group label="Background : 1100x707 px">
              <input type="file" @change="onFileChangeBG" />
            </b-form-group>
            <div v-for="(parameter, index) in parameters" style="margin-bottom: 20px; border: 1px solid black; padding: 5px" :key="index">
              <b-row style="margin-bottom: 15px">
                <b-col cols="12"
                  ><h3>{{ parameter.name }}</h3>
                  <b-form-checkbox :id="'checkbox-3' + index" v-model="parameter.display" :name="'checkbox-3' + index" value="block" unchecked-value="none"></b-form-checkbox>
                </b-col>
                <b-col>
                  <p>Couleur:</p>
                  <b-form-input type="color" label="Couleur" v-model="parameter.couleur" placeholder="Couleur"></b-form-input>
                </b-col>
                <b-col>
                  Italique
                  <b-form-checkbox :id="'checkbox-1' + index" v-model="parameter.fontStyle" :name="'checkbox-1' + index" value="italic" unchecked-value="normal"></b-form-checkbox>
                </b-col>
                <b-col>
                  Gras
                  <b-form-checkbox :id="'checkbox-2' + index" v-model="parameter.fontWeight" :name="'checkbox-2' + index" value="bold" unchecked-value="normal"></b-form-checkbox>
                </b-col>
                <b-col>
                  <p>Police:</p>
                  <b-form-select v-model="parameter.police" :options="fonts"></b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col> <circle-slider v-model="parameter.taille" :min="0" :max="200" @touchmove="$refs.input.blur()"></circle-slider> Taille: {{ parameter.taille }}px </b-col>
                <b-col> <circle-slider v-model="parameter.rotate" :min="-180" :max="180" @touchmove="$refs.input.blur()"></circle-slider> Angle: {{ parameter.rotate }}° </b-col>
                <b-col> <circle-slider v-model="parameter.offsetX" :min="0" :max="1100" @touchmove="$refs.input.blur()"></circle-slider>X: {{ parameter.offsetX }} </b-col>
                <b-col> <circle-slider v-model="parameter.offsetY" :min="0" :max="707" @touchmove="$refs.input.blur()"></circle-slider>Y: {{ parameter.offsetY }} </b-col>
              </b-row>
            </div>
            <b-button style="margin-bottom: 50px" v-if="!publish" v-on:click="saveTemplate">Enregistrer le template</b-button>
            <b-button style="margin-bottom: 50px" v-else>Le template est enregistré</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      url_bg: "",
      publish: false,
      old_diplomes: [],
      selected_epreuve: 0,
      diplome_name: "",
      parameters: {
        nom: {
          name: "nom",
          value: "BON",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        prenom: {
          name: "prenom",
          value: "Jean",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        distance: {
          name: "distance",
          value: "10KM",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        classement: {
          name: "classement",
          value: "1/302",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        temps: {
          name: "temps",
          value: "00:25:00",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        club: {
          name: "club",
          value: "Club des oliviers",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        vitesse: {
          name: "vitesse",
          value: "17,4 km/h",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
        classement_cat: {
          name: "classement catégorie",
          value: "1/120 (ESM)",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0,
        },
      },
      fonts: [
        {
          value: "Roboto",
          text: "Roboto",
        },
        {
          value: "Open Sans",
          text: "Open Sans",
        },
        {
          value: "Lato",
          text: "Lato",
        },
        {
          value: "Montserrat",
          text: "Montserrat",
        },
        {
          value: "Roboto Condensed",
          text: "Roboto Condensed",
        },
        {
          value: "Source Sans Pro",
          text: "Source Sans Pro",
        },
        {
          value: "Oswald",
          text: "Oswald",
        },
        {
          value: "Raleway",
          text: "Raleway",
        },
        {
          value: "Merriweather",
          text: "Merriweather",
        },
        {
          value: "Roboto Slab",
          text: "Roboto Slab",
        },
        {
          value: "Slabo 27px",
          text: "Slabo 27px",
        },
        {
          value: "PT Sans",
          text: "PT Sans",
        },
        {
          value: "Poppins",
          text: "Poppins",
        },
        {
          value: "Noto Sans",
          text: "Noto Sans",
        },
        {
          value: "Ubuntu",
          text: "Ubuntu",
        },
        {
          value: "Heebo",
          text: "Heebo",
        },
        {
          value: "Open Sans Condensed",
          text: "Open Sans Condensed",
        },
        {
          value: "Playfair Display",
          text: "Playfair Display",
        },
        {
          value: "vvx",
          text: "Police VVX",
        },
        {
          value: "LemonMilk",
          text: "Lemon Milk",
        },
      ],
    };
  },
  methods: {
    saveTemplate() {
      var data = new FormData();
      var _this = this;
      data.append("nom", this.diplome_name);
      data.append("url_bg", this.url_bg);
      axios.post("https://sportips.fr/plateformeResultats/saveDiplome.php", data).then(function (response) {
        var insert_id = response.data;

        if (insert_id > 0) {
          _this.saveMetaDiplome(insert_id);
        }
      });
    },
    saveMeta(id_diplome, meta) {
      var data = new FormData();
      var _this = this;
      data.append("id_diplome", id_diplome);
      data.append("name", meta.name);
      data.append("display", meta.display);
      data.append("fontWeight", meta.fontWeight);
      data.append("fontStyle", meta.fontStyle);
      data.append("offsetX", meta.offsetX);
      data.append("offsetY", meta.offsetY);
      data.append("police", meta.police);
      data.append("taille", meta.taille);
      data.append("couleur", meta.couleur);
      data.append("rotate", meta.rotate);
      axios.post("https://sportips.fr/plateformeResultats/saveDiplomeMeta.php", data).then(function (response) {});
    },
    saveMetaDiplome(id_diplome) {
      this.saveMeta(id_diplome, this.parameters.nom);
      this.saveMeta(id_diplome, this.parameters.prenom);
      this.saveMeta(id_diplome, this.parameters.distance);
      this.saveMeta(id_diplome, this.parameters.classement);
      this.saveMeta(id_diplome, this.parameters.temps);
      this.saveMeta(id_diplome, this.parameters.club);
      this.saveMeta(id_diplome, this.parameters.vitesse);
      this.saveMeta(id_diplome, this.parameters.classement_cat);
      this.publish = true;
    },
    onFileChangeBG() {
      var data = new FormData();
      var _this = this;
      this.selectedFile = event.target.files[0];
      data.append("image", this.selectedFile, this.selectedFile.name);
      axios.post("https://sportips.fr/plateformeResultats/uploadBgDiplome.php", data).then(function (response) {
        if (response.data.length > 0) {
          _this.url_bg = "https://sportips.fr/plateformeResultats/uploads/" + response.data;
        }
      });
    },
    loadFonts() {
      var _this = this;
      var data = new FormData();
      axios.post(`https://sportips.fr/plateformeResultats/getFonts.php`, data).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          _this.fonts.push({ value: response.data[i].value, text: response.data[i].value });
          _this.fonts.sort(function (a, b) {
            var x = a.text.toLowerCase();
            var y = b.text.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
        }
      });
    },
    loadOldDiplomes() {
      var _this = this;
      var data = new FormData();
      axios.post(`https://sportips.fr/plateformeResultats/getOldDiplomes.php`, data).then(function (response) {
        _this.old_diplomes = response.data;
      });
    },
  },
  created: function () {
    this.loadFonts();
    this.loadOldDiplomes();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BuildDiploma.vue